import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromTimeBlock from './time-block.reducer'
import { TimeBlockRoutingModule } from './time-block-routing.module'
import { TimeBlockEffects } from './time-block.effects'
import { TimeBlockSerializer } from './time-block.serializer'
import { TimeBlockService } from './time-block.service'
import { TimeBlockCreateEditModal } from './time-block-create-edit-modal/show.component'
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common'

@NgModule({
    imports: [
        TimeBlockRoutingModule,
        // BrowserModule,
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromTimeBlock.FEATURE_NAME, fromTimeBlock.timeBlockReducer),
        EffectsModule.forFeature([TimeBlockEffects])
    ],
    declarations: [TimeBlockCreateEditModal],
    exports: [],
    providers: [
        TimeBlockService,
        {
            provide: TimeBlockSerializer,
            useClass: TimeBlockSerializer
        }
    ]
})
export class TimeBlockModule {}
